module.exports = __webpack_public_path__ + "static/media/NotA.d6c6955a.jpg";